/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
  WhitelabelSettingReadModel,
  WhitelabelSettingWriteModel,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
    WhitelabelSettingReadModelFromJSON,
    WhitelabelSettingReadModelToJSON,
    WhitelabelSettingWriteModelFromJSON,
    WhitelabelSettingWriteModelToJSON,
} from '../models/index';

export interface WhitelabelGetTranslationsRequest {
    languageCode: string;
}

export interface WhitelabelResetSettingToDefaultPutRequest {
    key: string;
}

export interface WhitelabelUpdateLogoPutRequest {
    logo?: Blob;
}

export interface WhitelabelUpdateSettingPutRequest {
    whitelabelSettingWriteModel?: WhitelabelSettingWriteModel;
}

/**
 * 
 */
export class WhitelabelApi extends runtime.BaseAPI {

    /**
     */
    async whitelabelGetLogoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Whitelabel/logo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async whitelabelGetLogo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.whitelabelGetLogoRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async whitelabelGetSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WhitelabelSettingReadModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Whitelabel/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WhitelabelSettingReadModelFromJSON));
    }

    /**
     */
    async whitelabelGetSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WhitelabelSettingReadModel>> {
        const response = await this.whitelabelGetSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async whitelabelGetTranslationsRaw(requestParameters: WhitelabelGetTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling whitelabelGetTranslations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Whitelabel/translations.{languageCode}.json`.replace(`{${"languageCode"}}`, encodeURIComponent(String(requestParameters['languageCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async whitelabelGetTranslations(requestParameters: WhitelabelGetTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.whitelabelGetTranslationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async whitelabelResetAllSettingsToDefaultPutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Whitelabel/settings/reset-all`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async whitelabelResetAllSettingsToDefaultPut(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.whitelabelResetAllSettingsToDefaultPutRaw(initOverrides);
    }

    /**
     */
    async whitelabelResetSettingToDefaultPutRaw(requestParameters: WhitelabelResetSettingToDefaultPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling whitelabelResetSettingToDefaultPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Whitelabel/settings/reset/{key}`.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async whitelabelResetSettingToDefaultPut(requestParameters: WhitelabelResetSettingToDefaultPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.whitelabelResetSettingToDefaultPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async whitelabelUpdateLogoPutRaw(requestParameters: WhitelabelUpdateLogoPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['logo'] != null) {
            formParams.append('logo', requestParameters['logo'] as any);
        }

        const response = await this.request({
            path: `/api/Whitelabel/logo`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async whitelabelUpdateLogoPut(requestParameters: WhitelabelUpdateLogoPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.whitelabelUpdateLogoPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async whitelabelUpdateSettingPutRaw(requestParameters: WhitelabelUpdateSettingPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Whitelabel/settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WhitelabelSettingWriteModelToJSON(requestParameters['whitelabelSettingWriteModel']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async whitelabelUpdateSettingPut(requestParameters: WhitelabelUpdateSettingPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.whitelabelUpdateSettingPutRaw(requestParameters, initOverrides);
    }

}
